import React from 'react';
import PropTypes from 'prop-types';
import { MdKeyboardDoubleArrowLeft, MdKeyboardDoubleArrowRight } from "react-icons/md";

const Pagination = ({ itemsPerPage, totalItems, paginate, currentPage }) => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const maxVisiblePages = 10;
    let pageNumbers = [];

    if (totalPages <= maxVisiblePages) {
        // Show all pages if total pages are within the limit
        pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
    } else {
        // Handle pagination with '...'
        const left = Math.max(2, currentPage - Math.floor(maxVisiblePages / 2));
        const right = Math.min(totalPages - 1, left + maxVisiblePages - 3);

        pageNumbers = [1];

        if (left > 2) {
            pageNumbers.push("...");
        }

        for (let i = left; i <= right; i++) {
            pageNumbers.push(i);
        }

        if (right < totalPages - 1) {
            pageNumbers.push("...");
        }

        pageNumbers.push(totalPages);
    }

    const handleClick = (number, e) => {
        e.preventDefault();
        if (typeof number === "number" && number !== currentPage) {
            paginate(number);
        }
    };

    const paginationStyle = {
        display: 'flex',
        listStyle: 'none',
        justifyContent: 'center',
        padding: 0,
        marginTop: '20px'
    };

    const linkStyle = {
        color: 'white',
        float: 'left',
        padding: '8px 16px',
        textDecoration: 'none',
        border: '1px solid #ddd',
        margin: '0 2px',
        transition: 'background-color 0.3s ease',
        cursor: 'pointer'
    };

    const activeLinkStyle = {
        backgroundColor: '#007bff',
        color: 'white',
        borderColor: '#007bff'
    };

    const disabledLinkStyle = {
        color: '#ccc',
        pointerEvents: 'none',
        borderColor: '#ddd'
    };

    const arrowStyle = {
        verticalAlign: 'middle',
        fontSize: '1.2rem'
    };

    return (
        <nav>
            <ul className="text-white" style={paginationStyle}>
                {/* Previous Button */}
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <a
                        href="#"
                        onClick={(e) => currentPage > 1 && handleClick(currentPage - 1, e)}
                        className='page-link'
                        style={currentPage === 1 ? { ...linkStyle, ...disabledLinkStyle } : linkStyle}
                    >
                        <MdKeyboardDoubleArrowLeft style={arrowStyle} />
                    </a>
                </li>

                {/* Page Numbers */}
                {pageNumbers.map((number, index) => (
                    <li key={index} className={`page-item ${number === currentPage ? 'active' : ''}`}>
                        {number === "..." ? (
                            <span style={{ ...linkStyle, cursor: "default" }}>...</span>
                        ) : (
                            <a
                                onClick={(e) => handleClick(number, e)}
                                href="#"
                                className='page-link'
                                style={number === currentPage ? { ...linkStyle, ...activeLinkStyle } : linkStyle}
                            >
                                {number}
                            </a>
                        )}
                    </li>
                ))}

                {/* Next Button */}
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <a
                        href="#"
                        onClick={(e) => currentPage < totalPages && handleClick(currentPage + 1, e)}
                        className='page-link'
                        style={currentPage === totalPages ? { ...linkStyle, ...disabledLinkStyle } : linkStyle}
                    >
                        <MdKeyboardDoubleArrowRight style={arrowStyle} />
                    </a>
                </li>
            </ul>
        </nav>
    );
};

// PropTypes validation
Pagination.propTypes = {
    itemsPerPage: PropTypes.number.isRequired,
    totalItems: PropTypes.number.isRequired,
    paginate: PropTypes.func.isRequired,
    currentPage: PropTypes.number.isRequired
};

export default Pagination;
